import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap';
import { RequisitionActionModalComponent } from './requisition-action-modal.component';
import { VoiceInputModule } from 'src/app/shared/ai-assistant/voice-input/voice-input.module';
import { FormalizeCommentModule } from 'src/app/shared/ai-assistant/formalize-comment/formalize-comment.module';
import { ExternalNotesModule } from 'src/app/shared/external-notes/external-notes.module';
import { FillOrJoinCandidateModule } from 'src/app/shared/fill-or-join-candidate/fill-or-join-candidate.module';

@NgModule({
  declarations: [RequisitionActionModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    VoiceInputModule,
    FormalizeCommentModule,
    ExternalNotesModule,
    FillOrJoinCandidateModule
  ],
  exports: [RequisitionActionModalComponent],
  entryComponents: [RequisitionActionModalComponent]
})
export class RequisitionActionModalModule { }
